import ResourceCentreHero from "./ResourceCentreHero";

export default ResourceCentreHero;
